// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uNJ5c","newExpiryDate":"styles_newExpiryDate__1elfV","footer":"styles_footer__3GSt7"};